<template>
  <div>
    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    />

    <!-- Table Container Card -->
    <div no-body class="mb-0">
      <div class="mb-1 mt-1">
        <!-- Table Top -->
        <b-row>
          <!-- Search -->
          <b-col cols="12" md="12">
            <div class="d-flex  align-items-center justify-content-end">
              <!-- <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              /> -->
              <b-button
                variant="primary"
                @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Add Company</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <!--   <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        busy.sync="isBusy"
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
       
        <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="getAvatarUrl(data.item.companyLogo)"
                :text="avatarText(data.item.name)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'companies-edit', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'companies-edit', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.name }}
            </b-link>
          </b-media>
        </template>


        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
           

            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-primary"
              class="btn-icon ml-0"
              :to="{ name: 'companies-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle"></span>
            </b-button>

            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-primary"
              v-b-modal="modalId(data.item.id)"
              class="btn-icon ml-0"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle"></span>
            </b-button>
            <b-modal :id="'modal' + data.item.id" title="Confirm Delete?">
              <div class="alert">
                Are you sure to remove
               <b> {{data.item.fullName}}</b>
                ?
              </div>
              <div slot="modal-footer">
                <p>
                  <b-button
                    size="md"
                    class="float-left mr-1"
                    variant="secondary"
                    @click="$bvModal.hide('modal' + data.item.id)"
                  >
                    <i class="fas fa-times"></i> No
                  </b-button>
                  <b-button
                    size="md"
                    class="float-right"
                    variant="danger"
                    @click="deleteData(data.item.id)"
                  >
                    <i class="fas fa-check"></i> Yes
                  </b-button>
                </p>
              </div>
            </b-modal>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-start
            "
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
         
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-end
            "
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>-->

      <b-row>
        <b-col md="3" v-for="(listItem, index) in fetchData" :key="index">
          <b-card class="card-app-design">
            <b-row>
              <b-col class="d-flex align-items-start justify-content-start">
                <b-card-title class="mt-1 mb-75">
                  <h5>
                    <b-link :href="`/apps/companies/edit/${listItem.id}`">{{
                      listItem.name
                    }}</b-link>
                  </h5>
                </b-card-title>
              </b-col>

              <b-col md="1" class="d-flex align-items-end justify-content-end">
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  v-b-modal="modalId(listItem.id)"
                  class="btn-icon ml-0"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle"></span>
                </b-button>
                <b-modal :id="'modal' + listItem.id" title="Confirm Delete?">
                  <div class="alert">
                    Are you sure to remove
                    <b> {{ listItem.title }}</b>
                    ?
                  </div>
                  <div slot="modal-footer">
                    <p>
                      <b-button
                        size="md"
                        class="float-left mr-1"
                        variant="secondary"
                        @click="$bvModal.hide('modal' + listItem.id)"
                      >
                        <i class="fas fa-times"></i> No
                      </b-button>
                      <b-button
                        size="md"
                        class="float-right"
                        variant="danger"
                        @click="deleteData(listItem.id)"
                      >
                        <i class="fas fa-check"></i> Yes
                      </b-button>
                    </p>
                  </div>
                </b-modal>
              </b-col>
            </b-row>
            <b-card-text class="font-small-2 mb-0 min-h-40">
             {{ cutString(listItem.description, 80) }}
          </b-card-text>
                <div class="mb-1">
            <h6 class="section-label mt-0">Recruiters</h6>
            <b-avatar-group  class="mt-0  min-h-35" size="33">
              <b-avatar
              v-for="avatar in listItem.users"
              :key="avatar.avatarFileUrl"
              size="30"
               v-b-tooltip.hover.top="avatar.userFullName"
              :src="avatar.avatarFileUrl ? (avatar.avatarFileUrl.startsWith('data:image') ? avatar.avatarFileUrl : `data:image/jpeg;base64,${avatar.avatarFileUrl}`) : ''"

              class="pull-up"
            />
            </b-avatar-group>
          </div>
          <div class="design-planning-wrapper">
            <div class="design-planning w-50">
              <p class="card-text mb-0">Positions</p>
              <h6 class="mb-0">{{ listItem.totalJob }}</h6>
            </div>
            <div class="design-planning w-45">
              <p class="card-text mb-0">Open Positions</p>
              <h6 class="mb-0">{{ listItem.openJob }}</h6>
            </div>
          </div>
          <b-button
            class="m-0"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="warning"
            block
            :to="{ name: 'companies-edit', params: { id: listItem.id } }"
          >
            Show Details
          </b-button>

          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  VBModal,
   BCardText,
     BAvatarGroup,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import UsersListFilters from "./CompanyListFilters.vue";
import useUsersList from "./useCompanyList";
import userStoreModule from "../companyStoreModule";
import UserListAddNew from "./CompanyListAddNew.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "@/router";

export default {
  components: {
    UsersListFilters,
    UserListAddNew,
    ToastificationContent,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    VBModal,
    vSelect,
     BCardText,
       BAvatarGroup,
  
  },
  directives: {
   
    'b-tooltip': VBTooltip,
  },
  methods: {
    modalId(id) {
      return "modal" + id;
    },
    getAvatarUrl(Url) {
      return process.env.VUE_APP_BASE_URL + Url;
    },
    cutString(content, length) {
      let clamp = "...";
      return content.length > length
        ? content.slice(0, length) + clamp
        : content;
    },
    deleteData(id) {
      this.$bvModal.hide("modal" + id);
      store
        .dispatch("company/delete", {
          id: id,
        })
        .then((response) => {
          this.refetchData();
          // router.go("/apps/users/list");
        })
        .catch((error) => {
          for (const [key, value] of Object.entries(
            error.response.data.errors
          )) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "error",
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: value,
              },
            });
          }
        });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "company";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const isAddNewUserSidebarActive = ref(false);

    const roleOptions = [
      { label: "Administrator", value: 1 },
      { label: "AppUser", value: 2 },
    ];

    const planOptions = [
      { label: "Basic", value: "basic" },
      { label: "Company", value: "company" },
      { label: "Enterprise", value: "enterprise" },
      { label: "Team", value: "team" },
    ];

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const {
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      fetchData,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      fetchData,
      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    };
  },
};
</script>


<style lang="scss" >
@import "@core/scss/vue/libs/vue-select.scss";

.per-page-selector {
  width: 90px;
}
.min-h-40{
min-height: 40px !important;
}
.min-h-35{
min-height: 35px;
}

</style>
